import { Component, Input } from '@angular/core';
import {
  CadastroContratoDto,
  MaritalStatus,
  MeioPagamento,
  OwnerDto,
  PropertyDto,
  PropertyUsage,
  ReurbModalidade
} from '@usucampeao/lib-reurb-simplificado';

@Component({
  selector: 'usu-morador-usucampeao-2021',
  templateUrl: './morador-usucampeao-2021.html',
  styleUrls: ['./morador-usucampeao-2021.scss'],
})
export class MoradorUsucampeao2021Component {
  @Input() cadastro!: CadastroContratoDto;
  @Input() proprietario!: Partial<OwnerDto>;
  @Input() conjuge!: Partial<OwnerDto>;
  @Input() imovel!: Partial<PropertyDto>;
  @Input() isPrint = false;


  public get meioPagamento(): typeof MeioPagamento {
    return MeioPagamento
  }

  public get imovelTipo(): typeof PropertyUsage {
    return PropertyUsage
  }

  public get maritalStatus(): typeof MaritalStatus {
    return MaritalStatus
  }

  public get reurbModalidade(): typeof ReurbModalidade {
    return ReurbModalidade;
  }
}
